<form #subBudgetForm="ngForm" (ngSubmit)="onFormSubmit()">
    <mat-form-field>
        <input [(ngModel)]="model.description" i18n-placeholder id="description" matInput
               name="description" placeholder="Description" required>
    </mat-form-field>
    <div class="button-row">
        <button [disabled]="!subBudgetForm.form.valid" i18n mat-raised-button type="submit">Create sub-budget</button>
    </div>
</form>